// Keeps every time zone hidden field on the booking page in sync: the week calendar
// header (desktop), the pill above the date picker (phones) and the slot picker's
// (desktop monthly view). All are standard hidden inputs updated by the
// TimeZoneSelectComponent. When one changes, we propagate the value to the others and
// dispatch change so each receiving component can update its opener label.
// The first select is the source of truth for the initial value.
// Returns a teardown function to remove listeners on disconnect.

export const syncTimeZoneSelects = (selects) => {
  let syncing = false

  const propagate = (from) => {
    if (syncing) return
    syncing = true
    selects
      .filter((select) => select !== from)
      .forEach((select) => {
        select.value = from.value
        select.dispatchEvent(new Event('change', { bubbles: true }))
      })
    syncing = false
  }

  propagate(selects[0])

  const handlers = selects.map((select) => {
    const handler = () => propagate(select)
    select.addEventListener('change', handler)
    return [select, handler]
  })

  return () => {
    handlers.forEach(([select, handler]) =>
      select.removeEventListener('change', handler)
    )
  }
}
